import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useContactModStore = defineStore("contactModStore", () => {
        const contactMod = ref({
            id: null,
            name: '',
            users:[],
            branches:[],
        });
        const contactfields = ref({})
        const customFilters = ref([]);
        const systemFilters = ref([]);
        const leads = ref([]);
        // Get contact board
        const getContactMod = computed(() => contactMod.value);
        const getSystemFilters = computed(() => systemFilters.value);
        const getContactFields = computed(() => contactfields.value);

        // Set contact board
        const setContactMod = (value) => {
            contactMod.value = value;
        };

        // set contact board leads
        const setSystemFilters = (value) => {
            systemFilters.value = value;
        };
        const setContactFields = (value) => {
            contactfields.value = value;
        };

         // set contact board leads
         const setContactCustomFilters = (value) => {
            customFilters.value = value;
        };


        return { contactMod, customFilters,contactfields, getContactFields, setContactFields, systemFilters, getContactMod, getSystemFilters, customFilters, setContactMod, setSystemFilters, setContactCustomFilters};
    },
    {
        persist: true
    });
